var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.showNavMenu)?_c('menu-layout',[_c('router-view')],1):_vm._e(),_vm._v(" "),(!_vm.$route.meta.showNavMenu)?[_c('router-view')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }